// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Km3E","inputWrap":"Table_inputWrap__2HQof","col":"Table_col__2nDvQ","bmiTooltip":"Table_bmiTooltip__3rq2x"};